import request from './request'

function getUserRightsByUserCode(data) {
    return request('get','/qxapi/edu/users/userrightsbyusercode/' + data)
}

export default {
    getUserRightsByUserCode
}
